export default "__VITE_ASSET__a629e228__"